import type { HelpFile } from '../../types/help'
import { AttributeValueInputTestIds } from '../../../testids/AttributeValueInputTestIds'

export const attributeValueInputHelp: HelpFile = {
  docPage: '/docs/admin/attributes',
  texts: {
    [AttributeValueInputTestIds.validationError]:
      'Validierungsfehler für den eingegebenen Attributwert — Eingabe vor dem Absenden des Formulars korrigieren.',
    [AttributeValueInputTestIds.validationHint]:
      'Hinweis auf das erwartete Format oder die Einschränkungen für diesen Attributwert.',
  },
}
